<template>
  <Record class="SectionTemplate" :title="sectionTemplate.title">
    <Row>
      <Column :sm="4">
        <Set icon="record" :label="$t('name')">
          {{ sectionTemplate.name }}
        </Set>
      </Column>
      <Column :sm="4">
        <Set icon="record" :label="$t('engine')">
          {{ sectionTemplate.engine }}
        </Set>
      </Column>
      <Column :sm="4">
        <Set icon="record" :label="$t('template')">
          <template v-if="prompt">
            {{ prompt.name }}
          </template>
          <template v-else>
            {{ $t('noPrompt') }}
          </template>
        </Set>
      </Column>
    </Row>
    <RecordActions
      slot="actions"
      :doShowDelete="hasRole('>=ADMIN')"
      name="sectionTemplate"
      :record="sectionTemplate"
      routeName="SectionTemplate" />
  </Record>
</template>

<script>
import Record from '@components/Record'
import RecordActions from '@components/RecordActions'
import Set from '@components/Set'
import { getters } from '@utils'

export default {
  components: { Record, RecordActions, Set },
  props: {
    sectionTemplate: Object,
  },
  computed: {
    prompt() {
      if (!this.sectionTemplate.promptId) return

      return this.queryOne('prompt', this.sectionTemplate.promptId)
    },
    ...getters(),
  },
}
</script>

<style lang="scss">
.SectionTemplate {}
</style>

<i18n>
{
  "en": {
    "engine": "Engine",
    "template": "Template",
    "name": "Name",
    "noPrompt": "No prompt"
  }
}
</i18n>
